import { sample } from 'effector';
import { pending } from 'patronum/pending';
import { AlertProps } from '@mui/material';
import { signout } from '@features/common';
import { $isDetailOpen, closeDetail, pageUnmounted } from '../page/page.model';
import { setToastData } from '../toast/model/toast.model';
import {
  $assigneesReplaceByTypesData,
  $error,
  $isReplaceEmployee,
  $isReplaceEmployeeLoading,
  $replaceEmployeeForm,
  $ticketsCountByTypesIds,
  $typesForReplaceEmployee,
  assigneesReplaceByTypes,
  clearError,
  defaultReplaceEmployeeForm,
  errorOccured,
  fxAssigneesReplaceByTypes,
  fxGetCountsByTypesForReplaceAssignee,
  getTypesForReplaceEmployee,
  setReplaceEmployee,
} from './replace-employee.model';
import { GetCountsByTypesResponse } from './types/countsByTypesRequest';

$isReplaceEmployee
  .on(setReplaceEmployee, (_, status) => status)
  .reset([closeDetail, signout, pageUnmounted]);

$replaceEmployeeForm.reset([
  setReplaceEmployee,
  signout,
  pageUnmounted,
  fxAssigneesReplaceByTypes.doneData,
]);

$typesForReplaceEmployee
  .on(fxGetCountsByTypesForReplaceAssignee.doneData, (_, data) => data)
  .reset([setReplaceEmployee, signout, pageUnmounted, getTypesForReplaceEmployee]);

/** При открытии деталей, закрываю блок замены исполнителя */
sample({
  clock: $isDetailOpen,
  filter: (isDetailOpen) => isDetailOpen,
  fn: () => false,
  target: setReplaceEmployee,
});

/** Получаю данные типов для выбранного сотрудника */
sample({
  clock: getTypesForReplaceEmployee,
  filter: (id) => !!id,
  fn: (id) => ({ assignee_id: String(id) }),
  target: fxGetCountsByTypesForReplaceAssignee,
});

$assigneesReplaceByTypesData.on(assigneesReplaceByTypes, (_, data) => data);

/** Отправляю данные для замены уволенного сотрудника */
sample({
  clock: assigneesReplaceByTypes,
  fn: ({ appointedEmployee, replaceableEmployee, types, withoutTypeCheckbox }) => {
    return {
      new_assignee_id: appointedEmployee?.id ? Number(appointedEmployee?.id) : 0,
      assignee_id: replaceableEmployee?.id ? Number(replaceableEmployee?.id) : 0,
      types: types.map((type) => Number(type)),
      without_types: withoutTypeCheckbox,
    };
  },
  target: fxAssigneesReplaceByTypes,
});

/** Открываю toast при успешной замене */
sample({
  clock: fxAssigneesReplaceByTypes.doneData,
  source: {
    assigneesReplaceByTypesData: $assigneesReplaceByTypesData,
    ticketsCountByTypesIds: $ticketsCountByTypesIds,
  },
  fn: ({ assigneesReplaceByTypesData, ticketsCountByTypesIds }) => {
    const overAllTicketCount = assigneesReplaceByTypesData.types.reduce((acc, type) => {
      return acc + (ticketsCountByTypesIds[type] ?? 0);
    }, 0);

    return {
      visible: true,
      type: 'success' as AlertProps['severity'],
      text: `Изменены заявки: ${overAllTicketCount} шт. у сотрудника ${assigneesReplaceByTypesData.replaceableEmployee?.fullname}`,
      autoHideTimerMs: 6000,
    };
  },
  target: setToastData,
});

/** Сброс данных после успешной отправки формы замены */
sample({
  clock: fxAssigneesReplaceByTypes.doneData,
  fn: () => ({} as GetCountsByTypesResponse),
  target: $typesForReplaceEmployee,
});
sample({
  clock: fxAssigneesReplaceByTypes.doneData,
  fn: () => defaultReplaceEmployeeForm,
  target: $assigneesReplaceByTypesData,
});

$isReplaceEmployeeLoading
  .on(
    pending({
      effects: [fxGetCountsByTypesForReplaceAssignee, fxAssigneesReplaceByTypes],
    }),
    (_, status) => status
  )
  .reset([setReplaceEmployee, signout]);

$error
  .on(errorOccured, (_, { error }) => {
    return JSON.parse(error.message ?? '{}');
  })
  .reset([setReplaceEmployee, signout, clearError]);
